export const TRANSPORT_ORDER_STEP_GUIDES = {
  title1_filled: {
    stage: "Титул 1",
    title: "Заполняет грузоотправитель",
    actor: "Грузоотправитель",
    actorTitle: "Кто заполняет",
    summary: "Грузоотправитель создает заказ-заявку и заполняет исходные условия перевозки.",
    payload: "Условия заявки: участники, маршрут, груз, стоимость, порядок оплаты и комментарии по перевозке.",
    next: "После создания титул 1 нужно согласовать или подписать в Saby.",
    note: "На этом этапе перевозчик еще не заполняет фактические данные по транспорту и водителю.",
    tone: "shipper",
  },
  title1_signed: {
    stage: "Титул 1",
    title: "Подписывает грузоотправитель",
    actor: "Грузоотправитель или уполномоченное им лицо",
    actorTitle: "Кто подписывает",
    summary: "Подписанный титул 1 подтверждает исходные условия заказ-заявки и открывает следующий этап для перевозчика.",
    payload: "Юридически значимое подтверждение условий перевозки со стороны грузоотправителя.",
    next: "После согласования титула 1 перевозчик может заполнить титул 2.",
    note: "Если титул 1 еще не согласован, титул 2 остается недоступным.",
    tone: "shipper",
  },
  title2_filled: {
    stage: "Титул 2",
    title: "Заполняет перевозчик",
    actor: "Перевозчик",
    actorTitle: "Кто заполняет",
    summary: "Перевозчик заполняет свои данные по заявке: транспорт, прицеп, водителя и сведения для расчетов.",
    payload: "Фактические сведения перевозчика, которые дополняют исходную заявку грузоотправителя.",
    next: "После заполнения титул 2 нужно подписать или обновить его статус из Saby.",
    note: "Если Saby вернул ошибку, этап может требовать исправления или обновления статуса.",
    tone: "carrier",
  },
  title2_signed: {
    stage: "Титул 2",
    title: "Подписывает перевозчик",
    actor: "Перевозчик",
    actorTitle: "Кто подписывает",
    summary: "Подпись титула 2 перевозчиком завершает документооборот ЭЗЗ.",
    payload: "Юридически значимое подтверждение условий заказ-заявки со стороны перевозчика.",
    next: "После подписания титула 2 можно создать ЭТрН на основании этой ЭЗЗ.",
    note: "Если статус в Трако отличается от Saby, нужно обновить данные документа.",
    tone: "carrier",
  },
};

export const TRANSPORT_ORDER_FALLBACK_GUIDE = {
  stage: "Этап ЭЗЗ",
  actor: "Участник ЭЗЗ по текущему шагу",
  summary: "Этап документооборота заказ-заявки.",
  payload: "Сведения текущего этапа ЭЗЗ.",
  next: "Следующий участник получает документ после завершения текущего шага.",
};
